import { TextField } from "@mui/material";
import styled from "@emotion/styled";

export const InputStyled = styled(TextField)<{
  transparentBackground?: boolean;
}>`
  border-radius: 6px;
  border: 1px solid rgba(198, 200, 210, 1);
  box-shadow:
    0px -2px 3px rgba(228, 230, 242, 1) inset,
    0px 1px 3px 1px rgba(255, 255, 255, 1) inset,
    0px 2px 4px rgba(9, 9, 11, 0.08);
  opacity: 1;
  background-color: ${({ transparentBackground }) =>
    transparentBackground ? "transparent" : "rgba(252, 251, 248, 1)"};
  &:hover {
    border: 1px solid rgba(147, 150, 169, 1);
    box-shadow:
      0px -2px 3px rgba(228, 230, 242, 1) inset,
      0px 1px 3px 1px rgba(255, 255, 255, 1) inset,
      0px 3px 4px rgba(9, 9, 11, 0.1);
    opacity: 1;
  }
  &:focused {
    border: 1px solid rgba(90, 100, 148, 1);
    box-shadow:
      0px -2px 3px rgba(255, 255, 255, 1) inset,
      0px 1px 3px 1px rgba(190, 195, 216, 1) inset,
      0px 1px 4px rgba(9, 9, 11, 0.04);
    opacity: 1;
  }
  &:active {
    border: 1px solid rgba(198, 200, 210, 1);
    box-shadow:
      0px -2px 3px rgba(228, 230, 242, 1) inset,
      0px 1px 3px 1px rgba(255, 255, 255, 1) inset,
      0px 2px 4px rgba(9, 9, 11, 0.08);
    opacity: 1;
  }
  &:disabled {
    border: 1px solid rgba(237, 236, 229, 1);
    box-shadow:
      0px -2px 3px rgba(224, 222, 214, 1) inset,
      0px 1px 3px 1px rgba(250, 249, 244, 1) inset,
      0px 2px 4px rgba(9, 9, 11, 0.08);
    opacity: 1;
    background-color: rgba(237, 236, 229, 1);
  }
  div {
    background-color: ${({ transparentBackground }) =>
      transparentBackground
        ? "transparent !important"
        : "rgba(237, 236, 229, 1)"};
  }
`;

export const Input = ({ ...props }) => {
  return (
    <InputStyled
      {...props}
      variant="filled"
      slotProps={{
        input: {
          disableUnderline: true,
        },
      }}
    />
  );
};
